export default __webpack_public_path__ + "static/media/bg-assistance.d8ab12db.png";